import { useTranslation } from 'react-i18next'

type PerfilamientoConsentModalProps = {
  open: boolean
  isLoading?: boolean
  onAccept: () => void
  onClose: () => void
}

export function PerfilamientoConsentModal({
  open,
  isLoading = false,
  onAccept,
  onClose,
}: PerfilamientoConsentModalProps) {
  const { t } = useTranslation('perfilamiento')

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(214,214,214,0.82)] px-4 backdrop-blur-[1px]"
      onClick={onClose}
    >
      <div
        className="relative z-10 flex min-h-[430px] w-full max-w-[456px] flex-col items-center rounded-[10px] bg-[#eef7ff] px-8 py-10 text-center shadow-[0_10px_24px_rgba(31,58,88,0.12)]"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex h-11 w-11 items-center justify-center rounded-full border-2 border-[#2d9cff] text-[#2d9cff]">
          <svg
            aria-hidden="true"
            className="h-6 w-6"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
            <path
              d="M12 7.75v5.1"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <circle cx="12" cy="16.25" r="0.9" fill="currentColor" />
          </svg>
        </div>

        <h2 className="mt-6 max-w-[15.5rem] text-[1.95rem] font-normal leading-[1.08] text-[#20354a]">
          {t('consent.title')}
        </h2>

        <p className="mt-6 max-w-[16.75rem] whitespace-pre-line text-[1rem] leading-[1.2] text-[#20354a]">
          {t('consent.description')}
        </p>

        <button
          className="mt-[30px] inline-flex h-[54px] w-full max-w-[332px] items-center justify-center rounded-[8px] bg-[#3aa6f7] px-5 py-3 text-[1rem] font-normal text-white transition-colors duration-150 hover:bg-[#2f98ea] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[rgba(58,166,247,0.24)] disabled:cursor-not-allowed disabled:bg-[#a8d6fb] disabled:text-white/90"
          disabled={isLoading}
          onClick={onAccept}
          type="button"
        >
          {isLoading ? t('consent.loading') : t('consent.accept')}
        </button>
      </div>
    </div>
  )
}
